import React from 'react';
import radium from 'radium';
import earsImage from '../../static/images/ears.png';

const styles = {
  wrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 150px)',
    padding: 20,
  },
  image: {
    maxWidth: '100%',
    maxHeight: 'calc(100% - 60px)',
  },
};

function Ears() {
  return (
    <div style={styles.wrap}>
      <img role="presentation" src={earsImage} style={styles.image} />
    </div>
  );
}

export default radium(Ears);



// WEBPACK FOOTER //
// ./components/Ears/Ears.js